export const Endpoints = {
  actions: "actions",
  sessions: "sessions",
  users: "users",
  programs: "programs",
  programResources: "programresources",
  mandates: "mandates",
  mandateInfos: "mandateinfos",
  housings: "housings",
  buyers: "buyers",
  options: "options",
  pendingBuyerValidations: "pendingbuyervalidations",
  pendingOptionValidations: "pendingoptionvalidations",
  pendingReservationValidations: "pendingreservationvalidations",
  purchases: "purchases",
  resources: "resources",
  temporaryDirs: "temporarydirs",
  apiTokens: "apitokens",
  search: "search",
  contractTemplates: "contracttemplates",
  leaseTemplates: "leasetemplates",
  exports: "exports",
  fundraisingSteps: "fundraisingsteps",
  fiscalDevices: "fiscaldevices",
  sciArticles: "sciarticles",
};
